import { render, staticRenderFns } from "./AddProfile.vue?vue&type=template&id=7b3dffe4&scoped=true&"
import script from "./AddProfile.vue?vue&type=script&lang=js&"
export * from "./AddProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3dffe4",
  null
  
)

export default component.exports